import { Injectable } from '@angular/core';
import {ApiService} from './api.service';
import {Observable, of, Subject} from 'rxjs';
import {ModalService} from './modal.service';
import {AlertService} from './alert.service';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  public cacheStorage = {
    companies: <any[]> []
  }

  public companiesSubject: Subject<any> = new Subject<any>();

  /**
   * Constructor
   *
   * @param api
   * @param modal
   */
  constructor(
    private api:ApiService,
    private modal: ModalService,
    private alertService: AlertService
  )
  {


  }

  /**
   * Get all accounts
   */
  apiGetAccounts() {

    this.api.setEndpoint('account');
    return this.api.GET();

  }

  /**
   * Get a collection of account roles
   */
  apiGetAccountRoles() {
    this.api.setEndpoint('account/roles');
    return this.api.GET();
  }

  /**
   * Add a single account
   *
   * @param $params
   */
  apiAddAccount($params: any) {

    const params = {
      emailAddress: $params.emailAddress,
      firstName: $params.firstName,
      lastName: $params.lastName,
      roles: $params.roles,
      accountTargetGroups: $params.accountTargetGroups
    };
    this.api.setEndpoint('account');
    return this.api.POST(params);
  }

  /**
   * Update a single account
   *
   * @param $params
   */
  apiUpdateAccount($params: any) {

    const params = {
      id: $params.id,
      emailAddress: $params.emailAddress,
      firstName: $params.firstName,
      lastName: $params.lastName,
      roles: $params.roles,
      accountTargetGroups: $params.accountTargetGroups
    };
    this.api.setEndpoint('account/' + $params.id);
    return this.api.PUT(params);
  }

  /**
   * Delete a single account
   *
   * @param $id
   */
  apiDeleteAccount($id: any) {
    this.api.setEndpoint('account/' + $id);
    return this.api.DELETE();
  }

  /**
   * Get area of interest data
   */
  apiGetAreaofinterests() {

    this.api.setEndpoint('areaofinterest');
    return this.api.GET();

  }

  /**
   * Add a single area of interest
   *
   * @param $params
   */
  apiAddAreaofinterest($params:any) {

    const params = {
      name: $params.name,
      nameBe: $params.nameBe,
      nameEn: $params.nameEn,
      nameDe: $params.nameDe,
      nameFr: $params.nameFr,
      namePt: $params.namePt,
      description: $params.description,
      descriptionBe: $params.descriptionBe,
      descriptionEn: $params.descriptionEn,
      descriptionDe: $params.descriptionDe,
      descriptionFr: $params.descriptionFr,
      descriptionPt: $params.descriptionPt,
      tags: $params.tags
    };

    this.api.setEndpoint('areaofinterest');
    return this.api.POST(params);

  }


  /**
   * Update a single area of interest
   *
   * @param $params
   */
  apiUpdateAreaofinterest($params:any) {

    const params = {
      id: $params.id,
      name: $params.name,
      nameBe: $params.nameBe,
      nameEn: $params.nameEn,
      nameDe: $params.nameDe,
      nameFr: $params.nameFr,
      namePt: $params.namePt,
      description: $params.description,
      descriptionBe: $params.descriptionBe,
      descriptionEn: $params.descriptionEn,
      descriptionDe: $params.descriptionDe,
      descriptionFr: $params.descriptionFr,
      descriptionPt: $params.descriptionPt,
      tags: $params.tags,
    };

    this.api.setEndpoint('areaofinterest/' + $params.id);
    return this.api.PUT(params);

  }

  /**
   * Delete a single area of interest
   *
   * @param $id
   */
  apiDeleteAreaofinterest($id: string) {


    this.api.setEndpoint('areaofinterest/' + $id);
    return this.api.DELETE();

  }

  /**
   * Get education levels
   */
  apiGetEducationLevels() {

    this.api.setEndpoint('educationlevel');
    return this.api.GET();

  }

  /**
   * Add a single education level
   *
   * @param $params
   */
  apiAddEducationLevel($params: any) {

    const params = {
      name: $params.name,
      level: $params.level,
      schoolType: $params.schoolType,
      educationProfiles: $params.educationProfiles,
      phases: $params['phases'],
      regions: $params.regions
    };

    this.api.setEndpoint('educationlevel');
    return this.api.POST(params);
  }

  /**
   * Update a single education level
   *
   * @param $params
   */
  apiUpdateEducationLevel($params:any) {
    const params = {
      id: $params.id,
      name: $params.name,
      level: $params.level,
      schoolType: $params.schoolType,
      educationProfiles: $params.educationProfiles,
      phases: $params.phases,
      regions: $params.regions
    };

    this.api.setEndpoint('educationlevel/' + $params.id);
    return this.api.PUT(params);
  }

  /**
   * Delete a single education level
   *
   * @param $id
   */
  apiDeleteEducationLevel($id: string) {
    this.api.setEndpoint('educationlevel/' + $id);
    return this.api.DELETE();
  }

  /**
   * Get education programs
   */
  apiGetEducationprograms() {

    this.api.setEndpoint('educationprogram');
    return this.api.GET();

  }

  /**
   * Add a single education program
   *
   * @param $params
   */
  apiAddEducationProgram($params: any) {

    const params = {
      code: $params.code,
      title: $params.title,
      internationalTitle: $params.internationalTitle,
      schoolId: $params['schoolId'] ? $params['schoolId'] : null,
      educationLevelId: $params['educationLevelId'] ? $params['educationLevelId'] : null
    };

    this.api.setEndpoint('educationprogram');
    return this.api.POST(params);
  }

  /**
   * Update a single education program
   *
   * @param $params
   */
  apiUpdateEducationProgram($params:any) {
    const params = {
      id: $params.id,
      code: $params.code,
      title: $params.title,
      internationalTitle: $params.internationalTitle,
      schoolId: $params['schoolId'] ? $params['schoolId'] : null,
      educationLevelId: $params['educationLevelId'] ? $params['educationLevelId'] : null
    };

    this.api.setEndpoint('educationprogram/' + $params.id);
    return this.api.PUT(params);
  }

  /**
   * Delete a single education program
   *
   * @param $id
   */
  apiDeleteEducationProgram($id: string) {
    this.api.setEndpoint('educationprogram/' + $id);
    return this.api.DELETE();
  }


  /**
   * Get companies
   */
  apiGetCompanies($params:any|null = null) {

    this.api.setEndpoint('company');
    return this.api.GET($params);

  }

  /**
   * Register a new company
   *
   * Supply account data to make sure a company gets an account
   *
   * @param $params
   */
  apiCompanyRegister($params:any) {

    const params = {
      emailAddress: $params['emailAddress'],
      firstName: $params['firstName'],
      lastName: $params['lastName'],
      infix: $params['infix'],
      phoneNumber: $params['phoneNumber'],
      allowEmailNotifications: $params['allowEmailNotifications'],
      isSubscribedToNewsletter: $params['isSubscribedToNewsletter'],
      companyName: $params['companyName'],
      registrationNumber: $params['registrationNumber'],
      visitAddress: {
        street: $params['visitAddress']['street'],
        number: $params['visitAddress']['number'],
        numberSuffix: $params['visitAddress']['numberSuffix'],
        postalCode: $params['visitAddress']['postalCode'],
        city: $params['visitAddress']['city'],
        country: $params['visitAddress']['country']
      }
    };

    this.api.setEndpoint('company/register');
    return this.api.POST(params);
  }

  /**
   * Update a single company
   *
   * @param $params
   */
  apiUpdateCompany($params:any) {

    const params = {
      id: $params['id'],
      name: $params['name'],
      registrationNumber: $params['registrationNumber'],
      visitAddress: {
        street: $params['visitAddress']['street'],
        number: $params['visitAddress']['number'],
        numberSuffix: $params['visitAddress']['numberSuffix'],
        postalCode: $params['visitAddress']['postalCode'],
        city: $params['visitAddress']['city'],
        country: $params['visitAddress']['country']
      },
      status: $params['status'],
      companyAccounts: $params['companyAccounts']
    }

    this.api.setEndpoint('company/' + $params['id']);
    return this.api.PUT(params);

  }

  apiDeleteCompany($id: string) {
    this.api.setEndpoint('company/' + $id);
    return this.api.DELETE();
  }

  apiUpdateCompanyAccounts($id:string, $params:any) {
    this.api.setEndpoint('company/' + $id + '/accounts');
    return this.api.POST($params);
  }

  apiDeleteStudentprofile($id: string) {
    this.api.setEndpoint('studentprofile/' + $id);
    return this.api.DELETE();
  }

  /**
   * Add a single area of interest
   *
   * @param $params
   */
  apiAddSchool($params:any) {

    const params = {
      name: $params.name,
      address: {
        street: $params['address']['street'],
        number: $params['address']['number'],
        numberSuffix: $params['address']['numberSuffix'],
        postalCode: $params['address']['postalCode'],
        city: $params['address']['city'],
        country: $params['address']['country']
      }
    };

    this.api.setEndpoint('school');
    return this.api.POST(params);

  }


  /**
   * Update a single area of interest
   *
   * @param $params
   */
  apiUpdateSchool($params:any) {

    const params = {
      id: $params.id,
      name: $params.name,
      address: {
        street: $params['address']['street'],
        number: $params['address']['number'],
        numberSuffix: $params['address']['numberSuffix'],
        postalCode: $params['address']['postalCode'],
        city: $params['address']['city'],
        country: $params['address']['country']
      }
    };

    this.api.setEndpoint('school/' + $params.id);
    return this.api.PUT(params);

  }

  /**
   * Delete a single area of interest
   *
   * @param $id
   */
  apiDeleteSchool($id: string) {
    this.api.setEndpoint('school/' + $id);
    return this.api.DELETE();
  }


  /**
   * Error handler
   *
   * @param operation
   * @param result
   */
  handleError<T>(operation = 'operation', result?: T) {

    return (error: any): Observable<T> => {
      let errorMessage = '';

      if (error.hasOwnProperty('error')) {

        if (error.error.hasOwnProperty('title')) {
          errorMessage = error.error.title;
        }

        if (error.error.hasOwnProperty('errors')) {
          errorMessage = errorMessage + '<br>';
          for (const key of Object.keys(error.error.errors)) {
            const sError = error.error.errors[key];
            errorMessage = errorMessage + '<br>' + sError;
          }
        }

      }

      // Handle given operation
      switch (operation) {

        // No exceptional operations to handle

        default:
          //this.modal.Alert('Error', 'Something went wrong, please try again');
          this.alertService.error('Error: ' + errorMessage);
          break;

      }

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }


  apiAddTag($params: any) {
    // BE Tag entity uses a NullableKeyIdentityMap, so EF won't generate
    // the primary key on insert — POST without id 500s with
    // "primary key property 'Id' is null". Pre-generate a GUID here.
    const params = { id: crypto.randomUUID(), name: $params.name };
    this.api.setEndpoint('tag');
    return this.api.POST(params);
  }

  apiUpdateTag($params: any) {
    const params = { id: $params.id, name: $params.name };
    this.api.setEndpoint('tag/' + $params.id);
    return this.api.PUT(params);
  }

  apiDeleteTag($id: string) {
    this.api.setEndpoint('tag/' + $id);
    return this.api.DELETE();
  }

  getRegions()
  {

    this.api.setEndpoint('region');
    return this.api.GET();
  }


}
